import Reveal from "@/components/base/Reveal";

interface FarmerFilterBarProps {
  villages: string[];
  value: string;
  onChange: (village: string) => void;
  shown: number;
  total: number;
}

export default function FarmerFilterBar({
  villages,
  value,
  onChange,
  shown,
  total,
}: FarmerFilterBarProps) {
  const options = [
    { value: "all", label: "All Villages" },
    ...villages.map((village) => ({ value: village, label: village })),
  ];

  return (
    <Reveal className="mb-12 md:mb-16">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 flex flex-col sm:flex-row sm:items-end gap-4 md:gap-6">
        <div className="w-full sm:max-w-xs">
          <label
            htmlFor="farmer-village-filter"
            className="block text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-2"
          >
            Browse by village
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-accent-600 pointer-events-none">
              <i className="ri-map-pin-2-line text-base"></i>
            </span>
            <select
              id="farmer-village-filter"
              value={value}
              onChange={(event) => onChange(event.target.value)}
              className="w-full appearance-none bg-background-50 border border-background-300 text-sm font-medium text-foreground-900 pl-11 pr-10 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-accent-300 focus:border-accent-400 transition-colors cursor-pointer"
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <span className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-500 pointer-events-none">
              <i className="ri-arrow-down-s-line text-lg"></i>
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3 sm:ml-auto">
          <p className="text-sm text-foreground-600">
            Showing <span className="font-semibold text-foreground-950">{shown}</span> of {total}{" "}
            {total === 1 ? "farmer" : "farmers"}
          </p>
          {value !== "all" && (
            <button
              type="button"
              onClick={() => onChange("all")}
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700 bg-accent-50 border border-accent-200 px-3 py-2 rounded-md hover:bg-accent-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-refresh-line"></i>
              Clear
            </button>
          )}
        </div>
      </div>
    </Reveal>
  );
}